import useGetStoreInitialValues from './useGetStoreInitialValues'

export default useGetStoreInitialValues
